import {Component, Input} from "@angular/core";
import {UploadFormConfig} from "../upload-form-config";
import {environment} from "../../../../environments/environment";

@Component({
    selector: "app-symptom-holter-upload-form",
    templateUrl: "./symptom-holter-upload-form.component.html",
    standalone: false
})
export class SymptomHolterUploadFormComponent {
  private _formConfig?: UploadFormConfig;
  isEForm = environment.eforms;

  @Input() showPostMeasurementFields!: boolean;
  @Input() showPreMeasurementFields!: boolean;
  @Input() ecgTechnicianAnalysisOnlyEnabled!: boolean;
  @Input() isHome!: boolean;

  @Input()
  set formConfig(formConfig: UploadFormConfig) {
    this._formConfig = formConfig;
  }

  get formConfig(): UploadFormConfig {
    return this._formConfig!;
  }
}
